var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-grid.ts
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ChemistryLitElement } from "../../chemistry-lit-element";
import "../theming/design";
import { paddingAndMarginAttributes, withVariableAttribute } from "../token-helpers";
var ElementsGrid = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this["auto-fit-columns"] = "";
    this["auto-fill-columns"] = "";
    this.columns = "";
    this["auto-fit-rows"] = "";
    this["auto-fill-rows"] = "";
    this.rows = "";
    this.styles = () => {
      if (typeof this["auto-fit-columns"] === "boolean")
        throw new Error("You can use auto-fit-columns only with non 'fr' css width");
      if (typeof this["auto-fill-columns"] === "boolean")
        throw new Error("You can use auto-fill-columns only with non 'fr' css width");
      if (typeof this["auto-fit-rows"] === "boolean")
        throw new Error("You can use auto-fit-rows only with non 'fr' css width");
      if (typeof this["auto-fill-rows"] === "boolean")
        throw new Error("You can use auto-fill-rows only with non 'fr' css width");
      return {
        ":host": {
          display: "grid",
          boxSizing: "border-box"
        },
        ":host([auto-fit-columns])": {
          gridTemplateColumns: `repeat(auto-fit, minmax(${this["auto-fit-columns"]}, 1fr))`
        },
        ":host([auto-fill-columns])": {
          gridTemplateColumns: `repeat(auto-fill, minmax(${this["auto-fill-columns"]}, 1fr))`
        },
        ":host([columns])": {
          gridTemplateColumns: !isNaN(+(this.columns || 0)) ? `repeat(${this.columns}, 1fr)` : this.columns
        },
        ":host([auto-fit-rows])": {
          gridTemplateRows: `repeat(auto-fit, minmax(${this["auto-fit-rows"]}, 1fr))`
        },
        ":host([auto-fill-rows])": {
          gridTemplateRows: `repeat(auto-fill, minmax(${this["auto-fill-rows"]}, 1fr))`
        },
        ":host([rows])": {
          gridTemplateRows: !isNaN(+(this.rows || 0)) ? `repeat(${this.rows}, 1fr)` : this.rows
        },
        ...withVariableAttribute(
          "space",
          Object.keys(this.spacing),
          (size) => ({ gridGap: this.spacing[size] }),
          true
        ),
        ...paddingAndMarginAttributes(this.spacing, true),
        "::slotted([secondary])": { background: "#eee" }
      };
    };
  }
  render() {
    return html` <slot></slot> `;
  }
};
__decorateClass([
  property()
], ElementsGrid.prototype, "auto-fit-columns", 2);
__decorateClass([
  property()
], ElementsGrid.prototype, "auto-fill-columns", 2);
__decorateClass([
  property()
], ElementsGrid.prototype, "columns", 2);
__decorateClass([
  property()
], ElementsGrid.prototype, "auto-fit-rows", 2);
__decorateClass([
  property()
], ElementsGrid.prototype, "auto-fill-rows", 2);
__decorateClass([
  property()
], ElementsGrid.prototype, "rows", 2);
ElementsGrid = __decorateClass([
  customElement("x-grid")
], ElementsGrid);
export {
  ElementsGrid
};
